/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * newsCards
 */

const newsCards = {
    cfg:  {
        name: 'newsCards',
        items: [...document.querySelectorAll('.js-newsCards-filterItem')],
        initialValue: '0'
    },

    resizeGridItem(item) {
        // eslint-disable-next-line
        console.log('Resize Item');
        // const grid = document.getElementsByClassName('o-newsCards__itemWrapper')[0];
        const grid = item.parentElement;
        // eslint-disable-next-line
        let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'), 10);
        // eslint-disable-next-line
        let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'), 10);
        // eslint-disable-next-line
        let rowSpan = Math.ceil((item.querySelector('.m-card').clientHeight+rowGap)/(rowHeight+rowGap));
        item.style.gridRowEnd = `span ${rowSpan}`;
    },

    resizeAllGridItems() {
        // eslint-disable-next-line
        console.log('Init resizeAllGridItems ' + this.cfg.items.length);
        this.cfg.items.forEach((item) => {
            // eslint-disable-next-line
            console.log('Init resizeAllGridItems -> call resizeGridItem');
            this.resizeGridItem(item);
        });
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.items) {
                // eslint-disable-next-line
                console.log('Init Listener');
                this.resizeAllGridItems();
            }
        });

        window.addEventListener('resize', () => {
            if (this.cfg.items) {
                this.resizeAllGridItems();
            }
        });
    }
};

export default newsCards;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/newsCards/_script.js